import { guardArray } from "@msuite/utils/array";
import { useAppShellStore } from "../../app-shell";
import { Divider } from "../../divider";
import { useDisclosure } from "../../hooks";
import { cn } from "../../utils";
import type { NavigationItemType } from "../types";
import { SidebarNavigationItem } from "./sidebar-navigation-item";
import { SidebarNavigationLabel } from "./sidebar-navigation-label";

/** Props Interface */
interface SidebarNavigationGroupProps {
	navigationItem: NavigationItemType;
}

export function SidebarNavigationGroup({ navigationItem }: SidebarNavigationGroupProps) {
	/** Hooks */
	const { sidebarIsCollapsed } = useAppShellStore();
	const disclosure = useDisclosure({ defaultIsOpen: true });

	/** Render */
	return (
		<div className={cn("v-stack gap-1", "my-2")}>
			<div className="h-stack">
				{sidebarIsCollapsed ? (
					<Divider className="w-full mx-3" />
				) : (
					<SidebarNavigationLabel
						key={navigationItem.label}
						label={navigationItem.label}
						disclosure={disclosure}
					/>
				)}
			</div>
			{disclosure.isOpen && (
				<div className="v-stack gap-0">
					{guardArray(navigationItem.items).map((navigationItem) =>
						typeof navigationItem === "string" ? (
							navigationItem === "divider" || sidebarIsCollapsed ? null : (
								<SidebarNavigationLabel
									key={navigationItem}
									label={navigationItem}
								/>
							)
						) : (
							<SidebarNavigationItem
								navigationItem={navigationItem}
								key={navigationItem.to ?? navigationItem.label}
							/>
						),
					)}
				</div>
			)}
		</div>
	);
}
